var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "query-guidelines-content small text-secondary" },
      [
        _c("h5", { staticClass: "text-dark font-weight-bold mb-3" }, [
          _vm._v("How REVEAL prepared this search"),
        ]),
        _c("p", { staticClass: "mb-3" }, [
          _vm._v(
            " The LLM first reads your query as a biological intent statement, then extracts structured terms that can drive retrieval: phenotypes or traits, mechanism terms, gene anchors, and a short research context. "
          ),
        ]),
        _c("h6", { staticClass: "text-dark font-weight-bold mt-3 mb-2" }, [
          _vm._v("1. Separate user anchors from route expansion"),
        ]),
        _c("p", { staticClass: "mb-2" }, [
          _vm._v(
            " Genes directly named or aliased by you are tracked separately from additional genes introduced by routing. This helps the workflow preserve your original targets while allowing the search to include downstream or related pathway members. "
          ),
        ]),
        _c("h6", { staticClass: "text-dark font-weight-bold mt-3 mb-2" }, [
          _vm._v("2. Create multiple biological retrieval directions"),
        ]),
        _c("p", { staticClass: "mb-2" }, [
          _vm._v(
            " The extractor first expands your single query into 10 candidate biological query variations. It then selects the 3 most complementary directions, such as tissue expression, perturbation response, and genetic association. Each selected direction gets its own biological query variation and route-specific terms. "
          ),
        ]),
        _c("h6", { staticClass: "text-dark font-weight-bold mt-3 mb-2" }, [
          _vm._v("3. Keep embedding text biological, not repository-specific"),
        ]),
        _c("p", { staticClass: "mb-2" }, [
          _vm._v(
            " Retrieval directions avoid literal repository names in the text sent for semantic matching. Instead, they describe modalities such as transcript co-expression, perturbation signatures, or variant-to-trait evidence. Program or modality preferences are handled separately as structured routing hints when supported. "
          ),
        ]),
        _c("h6", { staticClass: "text-dark font-weight-bold mt-3 mb-2" }, [
          _vm._v("4. Preserve user genes during compact evidence building"),
        ]),
        _c("p", { staticClass: "mb-0" }, [
          _vm._v(
            " During data fetch, each route keeps top-scoring genes and also pins matching genes of interest when they appear in the returned data. Pinned genes are still judged by their scores and graph support, but they remain visible to the final synthesis step. "
          ),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }